"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.RawTextDefaultProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextSt = require("./Text.st.css");
var _context = require("../WixStyleReactMaskingProvider/context");
var _excluded = ["size", "secondary", "skin", "light", "weight", "tagName", "children", "ellipsis", "showDelay", "hideDelay", "appendTo", "flip", "fixed", "placement", "timeout", "maxWidth", "zIndex", "showTooltip", "listStyle", "id", "widows"],
  _excluded2 = ["dataHook", "className"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Text/RawText.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getStyleDataAttributes = styleAttributes => Object.keys(styleAttributes).reduce((acc, styleKey) => {
  acc["data-".concat(styleKey)] = styleAttributes[styleKey];
  return acc;
}, {});
var RawTextDefaultProps = exports.RawTextDefaultProps = {
  size: 'medium',
  secondary: false,
  skin: 'standard',
  light: false,
  weight: 'thin',
  tagName: 'span',
  listStyle: 'checkmark',
  widows: false
};
var RawText = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  var {
      size = RawTextDefaultProps.size,
      secondary = RawTextDefaultProps.secondary,
      skin = RawTextDefaultProps.skin,
      light = RawTextDefaultProps.light,
      weight = RawTextDefaultProps.weight,
      tagName = RawTextDefaultProps.tagName,
      children,
      ellipsis,
      showDelay,
      hideDelay,
      appendTo,
      flip,
      fixed,
      placement,
      timeout,
      maxWidth,
      zIndex,
      showTooltip,
      listStyle = RawTextDefaultProps.listStyle,
      id,
      widows = RawTextDefaultProps.widows
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  /* eslint-disable no-unused-vars */
  var {
      dataHook,
      className
    } = rest,
    textProps = (0, _objectWithoutProperties2.default)(rest, _excluded2);
  var styleAttributes = {
    size,
    secondary,
    skin,
    light,
    weight,
    widows,
    'list-style': listStyle
  };
  var styleDataAttributes = getStyleDataAttributes(styleAttributes);
  var childrenWidows = (0, _react.useMemo)(() => {
    if (!widows || typeof children !== 'string' || !children) {
      return children;
    }
    var textArray = children.split(' ');
    if (textArray.length <= 2) return children;
    var arrLength = textArray.length;
    var newChildrenArr = textArray.slice(0, arrLength - 2);
    newChildrenArr.push(textArray[arrLength - 2] + '\u00A0' + textArray[arrLength - 1]);
    return newChildrenArr.join(' ');
  }, [children, widows]);
  return /*#__PURE__*/_react.default.createElement(_context.WixStyleReactMaskingContext.Consumer, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 7
    }
  }, _ref2 => {
    var {
      maskingClassNames
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(tagName, _objectSpread(_objectSpread({
      ref,
      id
    }, textProps), {}, {
      'data-hook': dataHook,
      'data-mask': !!maskingClassNames,
      className: (0, _TextSt.st)(_TextSt.classes.root, styleAttributes, className, maskingClassNames)
    }, styleDataAttributes), childrenWidows);
  });
});
RawText.displayName = 'Text';
RawText.propTypes = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes.default.string,
  /** class to be applied to the root element */
  className: _propTypes.default.string,
  /** tag name that will be rendered */
  tagName: _propTypes.default.string,
  /** Styling to be applied to the root element */
  style: _propTypes.default.object,
  /** font size of the text */
  size: _propTypes.default.oneOf(['tiny', 'small', 'medium']),
  /** any nodes to be rendered (usually text nodes) */
  children: _propTypes.default.any,
  /** is the text type is secondary. Affects the font color */
  secondary: _propTypes.default.bool,
  /** skin color of the text */
  skin: _propTypes.default.oneOf(['standard', 'success', 'error', 'premium', 'disabled', 'primary']),
  /** make the text color lighter */
  light: _propTypes.default.bool,
  /** font weight of the text */
  weight: _propTypes.default.oneOf(['thin', 'normal', 'bold']),
  /** Applied as id HTML attribute */
  id: _propTypes.default.string,
  /** if true it will support widows in the text */
  widows: _propTypes.default.bool
};
var _default = exports.default = RawText;
//# sourceMappingURL=RawText.js.map